import React, { useState, useEffect } from 'react';
import {
  CheckCircle,
  XCircle,
  Calendar,
  Database,
  Loader2
} from 'lucide-react';
import { apiService } from '../services/api';
import { useModal } from '../contexts/ModalContext';
import './Integrations.css';

// Gmail official logo
const GmailIcon = () => (
  <svg viewBox="52 42 88 66">
    <path fill="#4285f4" d="M58 108h14V74L52 59v43c0 3.32 2.69 6 6 6"/>
    <path fill="#34a853" d="M120 108h14c3.32 0 6-2.69 6-6V59l-20 15"/>
    <path fill="#fbbc04" d="M120 48v26l20-15v-8c0-7.42-8.47-11.65-14.4-7.2"/>
    <path fill="#ea4335" d="M72 74V48l24 18 24-18v26L96 92"/>
    <path fill="#c5221f" d="M52 51v8l20 15V48l-5.6-4.2c-5.94-4.45-14.4-.22-14.4 7.2"/>
  </svg>
);

// Notion official logo
const NotionIcon = () => (
  <svg viewBox="0 0 100 100" fill="none">
    <path d="M6.017 4.313l55.333 -4.087c6.797 -0.583 8.543 -0.19 12.817 2.917l17.663 12.443c2.913 2.14 3.883 2.723 3.883 5.053v68.243c0 4.277 -1.553 6.807 -6.99 7.193L24.467 99.967c-4.08 0.193 -6.023 -0.39 -8.16 -3.113L3.3 79.94c-2.333 -3.113 -3.3 -5.443 -3.3 -8.167V11.113c0 -3.497 1.553 -6.413 6.017 -6.8z" fill="#fff"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M61.35 0.227l-55.333 4.087C1.553 4.7 0 7.617 0 11.113v60.66c0 2.723 0.967 5.053 3.3 8.167l13.007 16.913c2.137 2.723 4.08 3.307 8.16 3.113l64.257 -3.89c5.433 -0.387 6.99 -2.917 6.99 -7.193V20.64c0 -2.21 -0.873 -2.847 -3.443 -4.733L74.167 3.143c-4.273 -3.107 -6.02 -3.5 -12.817 -2.917zM25.92 19.523c-5.247 0.353 -6.437 0.433 -9.417 -1.99L8.927 11.507c-0.77 -0.78 -0.383 -1.753 1.557 -1.947l53.193 -3.887c4.467 -0.39 6.793 1.167 8.54 2.527l9.123 6.61c0.39 0.197 1.36 1.36 0.193 1.36l-54.933 3.307 -0.68 0.047zM19.803 88.3V30.367c0 -2.53 0.777 -3.697 3.103 -3.893L86 22.78c2.14 -0.193 3.107 1.167 3.107 3.693v57.547c0 2.53 -0.39 4.67 -3.883 4.863l-60.377 3.5c-3.493 0.193 -5.043 -0.97 -5.043 -4.083zm59.6 -54.827c0.387 1.75 0 3.5 -1.75 3.7l-2.91 0.577v42.773c-2.527 1.36 -4.853 2.137 -6.797 2.137 -3.107 0 -3.883 -0.973 -6.21 -3.887l-19.03 -29.94v28.967l6.02 1.363s0 3.5 -4.857 3.5l-13.39 0.777c-0.39 -0.78 0 -2.723 1.357 -3.11l3.497 -0.97v-38.3L30.48 40.667c-0.39 -1.75 0.58 -4.277 3.3 -4.473l14.367 -0.967 19.8 30.327v-26.83l-5.047 -0.58c-0.39 -2.143 1.163 -3.7 3.103 -3.89l13.4 -0.78z" fill="#000"/>
  </svg>
);

// Outlook official logo
const OutlookIcon = () => (
  <svg viewBox="0 0 32 32">
    <path fill="#0364B8" d="M19.484 7.937v5.477l1.916 1.205a.489.489 0 00.21.063.5.5 0 00.229-.063l8.677-5.494a1.5 1.5 0 00-.849-2.258 1.5 1.5 0 00-.187-.013H19.484z"/>
    <path fill="#0078D4" d="M19.484 15.457l1.747 1.2a.522.522 0 00.543 0c-.3.181 8.073-5.378 8.073-5.378v10.795a1.5 1.5 0 01-1.425 1.569H19.484V15.457z"/>
    <path fill="#28A8EA" d="M10.44 12.932a4.215 4.215 0 011.439-3.166 4.376 4.376 0 013.267-1.207 4.292 4.292 0 013.204 1.207 4.213 4.213 0 011.439 3.166v.56h.004V23.65H11.22a1.5 1.5 0 01-1.5-1.5v-9.223h.72v.005z"/>
    <path fill="#0078D4" d="M18.038 7.937h-6.766v15.756h8.22V9.437a1.5 1.5 0 00-1.453-1.5z"/>
    <path fill="#50D9FF" d="M17.315 22.17H6.228a1.5 1.5 0 01-1.5-1.5V9.45a1.5 1.5 0 011.5-1.5h11.087a1.5 1.5 0 011.5 1.5v11.22a1.5 1.5 0 01-1.5 1.5z"/>
    <path fill="#0364B8" d="M14.591 11.437a3.75 3.75 0 00-5.36.107 3.75 3.75 0 00.107 5.36 3.75 3.75 0 005.36-.107c1.424-1.5 1.393-3.86-.107-5.36zm-2.573 4.496a1.875 1.875 0 112.4-2.88 1.875 1.875 0 01-2.4 2.88z"/>
  </svg>
);

// LinkedIn icon as SVG
const LinkedInIcon = () => (
  <svg viewBox="0 0 24 24" fill="#0A66C2">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

// Google Calendar icon as SVG (official logo)
const GoogleCalendarIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <rect x="3" y="4" width="18" height="18" rx="2" fill="#FFFFFF" stroke="#4285F4" strokeWidth="1.5"/>
    <rect x="3" y="4" width="18" height="5" fill="#4285F4"/>
    <rect x="7" y="2" width="2" height="4" rx="1" fill="#4285F4"/>
    <rect x="15" y="2" width="2" height="4" rx="1" fill="#4285F4"/>
    <rect x="6" y="11" width="3" height="3" rx="0.5" fill="#EA4335"/>
    <rect x="10.5" y="11" width="3" height="3" rx="0.5" fill="#FBBC04"/>
    <rect x="15" y="11" width="3" height="3" rx="0.5" fill="#34A853"/>
    <rect x="6" y="16" width="3" height="3" rx="0.5" fill="#4285F4"/>
    <rect x="10.5" y="16" width="3" height="3" rx="0.5" fill="#EA4335"/>
    <rect x="15" y="16" width="3" height="3" rx="0.5" fill="#FBBC04"/>
  </svg>
);

// Outlook Calendar icon as SVG (based on Outlook branding)
const OutlookCalendarIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <rect x="3" y="4" width="18" height="18" rx="2" fill="#FFFFFF" stroke="#0078D4" strokeWidth="1.5"/>
    <rect x="3" y="4" width="18" height="5" fill="#0078D4"/>
    <rect x="7" y="2" width="2" height="4" rx="1" fill="#0078D4"/>
    <rect x="15" y="2" width="2" height="4" rx="1" fill="#0078D4"/>
    <rect x="6" y="11" width="3" height="3" rx="0.5" fill="#0364B8"/>
    <rect x="10.5" y="11" width="3" height="3" rx="0.5" fill="#0078D4"/>
    <rect x="15" y="11" width="3" height="3" rx="0.5" fill="#50D9FF"/>
    <rect x="6" y="16" width="3" height="3" rx="0.5" fill="#0078D4"/>
    <rect x="10.5" y="16" width="3" height="3" rx="0.5" fill="#0364B8"/>
    <rect x="15" y="16" width="3" height="3" rx="0.5" fill="#28A8EA"/>
  </svg>
);

// iMessage icon as SVG
const IMessageIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path d="M12 2C6.477 2 2 6.027 2 11c0 2.247.894 4.298 2.36 5.845L3 22l5.155-1.36C9.295 21.186 10.612 21.5 12 21.5c5.523 0 10-4.027 10-9S17.523 2 12 2z" fill="#34C759"/>
    <ellipse cx="7.5" cy="11" rx="1.25" ry="1.25" fill="#fff"/>
    <ellipse cx="12" cy="11" rx="1.25" ry="1.25" fill="#fff"/>
    <ellipse cx="16.5" cy="11" rx="1.25" ry="1.25" fill="#fff"/>
  </svg>
);

interface IntegrationStatus {
  connected: boolean;
  email?: string;
  needsReconnect?: boolean;
  pageId?: string | null;
  lastSync?: string | null;
}

const Integrations: React.FC = () => {
  const { openModal } = useModal();
  const [outlookStatus, setOutlookStatus] = useState<IntegrationStatus | null>(null);
  const [gmailStatus, setGmailStatus] = useState<IntegrationStatus | null>(null);
  const [notionStatus, setNotionStatus] = useState<IntegrationStatus | null>(null);
  const [linkedinStatus, setLinkedinStatus] = useState<IntegrationStatus | null>(null);
  const [googleCalendarStatus, setGoogleCalendarStatus] = useState<IntegrationStatus | null>(null);
  const [outlookCalendarStatus, setOutlookCalendarStatus] = useState<IntegrationStatus | null>(null);
  const [imessageStatus, setImessageStatus] = useState<IntegrationStatus | null>(null);
  const [loading, setLoading] = useState({
    outlook: true,
    gmail: true,
    notion: true,
    linkedin: true,
    googleCalendar: true,
    outlookCalendar: true,
    imessage: true
  });
  const [actionLoading, setActionLoading] = useState<string | null>(null);

  useEffect(() => {
    checkAllStatuses();
  }, []);

  const checkAllStatuses = async () => {
    // Check Outlook status
    try {
      const status = await apiService.getOutlookStatus();
      const outlookConnected = {
        connected: status.connected,
        email: status.profile?.email,
        needsReconnect: status.needsReconnect
      };
      setOutlookStatus(outlookConnected);
      // Outlook Calendar uses the same connection
      setOutlookCalendarStatus({ connected: status.connected });
    } catch (error) {
      console.error('Failed to check Outlook status:', error);
      setOutlookStatus({ connected: false });
      setOutlookCalendarStatus({ connected: false });
    } finally {
      setLoading(prev => ({ ...prev, outlook: false, outlookCalendar: false }));
    }

    // Check Gmail status
    try {
      const status = await apiService.getGmailStatus();
      const gmailConnected = {
        connected: status.connected,
        email: status.profile?.email,
        needsReconnect: status.needsReconnect
      };
      setGmailStatus(gmailConnected);
      // Google Calendar uses the same connection
      setGoogleCalendarStatus({ connected: status.connected });
    } catch (error) {
      console.error('Failed to check Gmail status:', error);
      setGmailStatus({ connected: false });
      setGoogleCalendarStatus({ connected: false });
    } finally {
      setLoading(prev => ({ ...prev, gmail: false, googleCalendar: false }));
    }

    // Check Notion status
    try {
      const status = await apiService.getNotionStatus();
      setNotionStatus({
        connected: status.connected,
        pageId: status.pageId,
        lastSync: status.lastSync
      });
    } catch (error) {
      console.error('Failed to check Notion status:', error);
      setNotionStatus({ connected: false });
    } finally {
      setLoading(prev => ({ ...prev, notion: false }));
    }

    // LinkedIn and iMessage - check user data
    try {
      const response = await apiService.getCurrentUser();
      const user = response.user || response;
      setLinkedinStatus({
        connected: user.connectionsImported === true
      });
      setImessageStatus({
        connected: !!user.phone
      });
    } catch (error) {
      console.error('Failed to check user status:', error);
      setLinkedinStatus({ connected: false });
      setImessageStatus({ connected: false });
    } finally {
      setLoading(prev => ({ ...prev, linkedin: false, imessage: false }));
    }
  };

  const handleConnect = (service: string) => {
    const baseUrl = process.env.REACT_APP_API_URL?.replace(/\/api$/, '') || 'http://localhost:3001';
    switch (service) {
      case 'outlook':
        window.location.href = `${baseUrl}/api/outlook/connect`;
        break;
      case 'gmail':
        window.location.href = `${baseUrl}/api/gmail/connect`;
        break;
      case 'notion':
        window.location.href = `${baseUrl}/api/notion/auth/connect`;
        break;
      case 'linkedin':
        openModal('linkedInImport', {
          onComplete: (skipped?: boolean) => {
            if (!skipped) {
              setLinkedinStatus({ connected: true });
            }
          }
        });
        break;
      case 'googleCalendar':
        // Google Calendar uses Gmail OAuth
        window.location.href = `${baseUrl}/api/gmail/connect`;
        break;
      case 'outlookCalendar':
        // Outlook Calendar uses Outlook OAuth
        window.location.href = `${baseUrl}/api/outlook/connect`;
        break;
      case 'imessage':
        // Open phone walkthrough to add phone number
        openModal('phoneWalkthrough', {
          onComplete: () => {
            checkAllStatuses();
          }
        });
        break;
    }
  };

  const handleDisconnect = async (service: string) => {
    setActionLoading(service);
    try {
      switch (service) {
        case 'outlook':
        case 'outlookCalendar':
          // Disconnecting either Outlook or Outlook Calendar disconnects both
          await apiService.disconnectOutlook();
          setOutlookStatus({ connected: false });
          setOutlookCalendarStatus({ connected: false });
          break;
        case 'gmail':
        case 'googleCalendar':
          // Disconnecting either Gmail or Google Calendar disconnects both
          await apiService.disconnectGmail();
          setGmailStatus({ connected: false });
          setGoogleCalendarStatus({ connected: false });
          break;
        case 'notion':
          await apiService.disconnectNotion();
          setNotionStatus({ connected: false });
          break;
      }
    } catch (error) {
      console.error(`Failed to disconnect ${service}:`, error);
    } finally {
      setActionLoading(null);
    }
  };

  const renderIntegrationCard = (
    name: string,
    description: string,
    icon: React.ReactNode,
    status: IntegrationStatus | null,
    isLoading: boolean,
    serviceKey: string,
    isDisabled?: boolean,
    disabledReason?: string
  ) => {
    const isConnected = status?.connected;
    const isActionLoading = actionLoading === serviceKey;
    const isDisabledState = isDisabled && !isConnected;

    return (
      <div className={`integration-card ${isDisabledState ? 'disabled' : ''}`}>
        <div className="integration-header">
          <div className="integration-icon">
            {icon}
          </div>
          <h3 className="integration-title">{name}</h3>
        </div>
        <p className="integration-description">{description}</p>

        <div className="integration-status">
          {isConnected ? (
            <div className="status-connected">
              <CheckCircle size={16} />
              <span>Connected{status?.email ? ` as ${status.email}` : ''}</span>
            </div>
          ) : (
            <div className="status-disconnected">
              <XCircle size={16} />
              <span>Not connected</span>
            </div>
          )}
        </div>

        {status?.needsReconnect && (
          <div className="reconnect-warning">
            Connection needs to be refreshed. Please reconnect.
          </div>
        )}

        {isDisabledState && disabledReason && (
          <div className="reconnect-warning" style={{ backgroundColor: '#fef3c7', borderColor: '#fde68a', color: '#92400e' }}>
            {disabledReason}
          </div>
        )}

        <div className="integration-actions">
          {isConnected ? (
            <button
              className="disconnect-button"
              onClick={() => handleDisconnect(serviceKey)}
              disabled={isActionLoading}
            >
              {isActionLoading ? (
                <>
                  <Loader2 className="spin" size={16} />
                  Disconnecting...
                </>
              ) : (
                <>
                  <XCircle size={16} />
                  Disconnect
                </>
              )}
            </button>
          ) : (
            <button
              className="connect-button"
              onClick={() => handleConnect(serviceKey)}
              disabled={isLoading || isDisabledState}
              style={isDisabledState ? {
                opacity: 0.5,
                cursor: 'not-allowed',
                backgroundColor: '#e5e7eb',
                color: '#9ca3af'
              } : undefined}
            >
              Connect {name}
            </button>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="integrations-page">
      <div className="integrations-header">
        <h1>Integrations</h1>
      </div>

      <div className="integrations-grid">
        {renderIntegrationCard(
          'Outlook',
          'Track email history and automatically log all communications with your contacts. Sending emails coming soon.',
          <OutlookIcon />,
          outlookStatus,
          loading.outlook,
          'outlook',
          gmailStatus?.connected === true,
          gmailStatus?.connected ? 'Please disconnect Gmail first to connect Outlook' : undefined
        )}

        {renderIntegrationCard(
          'Gmail',
          'View conversation history and automatically log all email interactions with your contacts. Sending emails coming soon.',
          <GmailIcon />,
          gmailStatus,
          loading.gmail,
          'gmail',
          outlookStatus?.connected === true,
          outlookStatus?.connected ? 'Only one email can be connected at a time. Please disconnect Outlook first to connect Gmail' : undefined
        )}

        {renderIntegrationCard(
          'Notion',
          'Import contacts from Notion databases and keep them in sync. Changes in Notion automatically update in Remi.',
          <NotionIcon />,
          notionStatus,
          loading.notion,
          'notion'
        )}

        {renderIntegrationCard(
          'LinkedIn',
          'Import your LinkedIn connections and track their posts. Auto-scraping profile details like company and location information is coming soon.',
          <LinkedInIcon />,
          linkedinStatus,
          loading.linkedin,
          'linkedin'
        )}

        {renderIntegrationCard(
          'Google Calendar',
          'View upcoming meetings with contacts and see meeting history on contact profiles. Scheduling events coming soon.',
          <GoogleCalendarIcon />,
          googleCalendarStatus,
          loading.googleCalendar,
          'googleCalendar'
        )}

        {renderIntegrationCard(
          'Outlook Calendar',
          'View upcoming meetings with contacts and see meeting history on contact profiles. Scheduling events coming soon.',
          <OutlookCalendarIcon />,
          outlookCalendarStatus,
          loading.outlookCalendar,
          'outlookCalendar'
        )}

        {renderIntegrationCard(
          'iMessage',
          'Send and receive iMessages directly from Remi. Requires your phone number to be connected. Contact export coming soon.',
          <IMessageIcon />,
          imessageStatus,
          loading.imessage,
          'imessage'
        )}
      </div>
    </div>
  );
};

export default Integrations;
